export const LangTexts = {
  en: {
    categories: 'Categories',
    genres: 'Genres',
    mainCategories: [
      { label: 'Popular', value: 'popular' },
      { label: 'Top Rated', value: 'top_rated' },
      { label: 'Upcoming', value: 'upcoming' },
    ],
  },
  'pt-BR': {
    categories: 'Categorias',
    genres: 'Gêneros',
    mainCategories: [
      { label: 'Popular', value: 'popular' },
      { label: 'Melhor Avaliados', value: 'top_rated' },
      { label: 'Novos', value: 'upcoming' },
    ],
  },
};
